import { TooltipProvider } from "@ariakit/react";
import { Broadcast, CloudSlash, Lightning } from "@phosphor-icons/react";
import {
  IconButton,
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
} from "@replicate/ui";
import type { Version } from "../types";
import { route } from "../urls";
import CopyIconButton from "./copy-icon-button";

interface VersionIconProps {
  version: Version;
}

export function VersionIcons({ version }: VersionIconProps) {
  const streamable = version._extras.is_streamable;
  const disabled = version.disabled;
  const id = version.id;
  const trainable = version._extras.is_trainable;
  const hotswappable_base = version._extras.is_hotswappable_base;

  return (
    <div className="flex items-center gap-2">
      <CopyIconButton content={id} label="Copy version ID" />
      {disabled && (
        <TooltipProvider>
          <TooltipAnchor>
            <CloudSlash />
          </TooltipAnchor>
          <Tooltip>
            <span>This version is disabled</span>
            <TooltipArrow />
          </Tooltip>
        </TooltipProvider>
      )}
      {streamable && (
        <TooltipProvider>
          <TooltipAnchor
            render={
              <IconButton
                // biome-ignore lint/a11y/useAnchorContent: Content is provided by TooltipAnchor
                render={<a href={route("docs_streaming")} />}
                size="sm"
                variant="clear"
              />
            }
          >
            <Broadcast weight="fill" />
          </TooltipAnchor>
          <Tooltip className="w-64 text-center">
            <span>
              This version supports streaming.{" "}
              <a
                href={route("docs_streaming")}
                className="underline no-default no-focus"
              >
                Check out our documentation
              </a>
            </span>
            <TooltipArrow />
          </Tooltip>
        </TooltipProvider>
      )}
      {trainable && hotswappable_base && (
        <TooltipProvider>
          <TooltipAnchor
            render={
              <IconButton
                render={
                  // biome-ignore lint/a11y/useAnchorContent: Content is provided by TooltipAnchor
                  <a
                    href={route("blog_detail", {
                      slug: "fine-tune-cold-boots",
                    })}
                  />
                }
                size="sm"
                variant="clear"
              />
            }
          >
            <Lightning weight="fill" />
          </TooltipAnchor>
          <Tooltip className="text-center">
            <span>Trained models boot fast</span>
            <TooltipArrow />
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
